module.exports = __webpack_public_path__ + "img/register-icon.8ad4f2d7.svg";